import { Component, Input, OnInit, Output, EventEmitter, ViewEncapsulation } from '@angular/core';
import { BlobStorageService } from '../../services/blobStorage.service';

@Component({
  selector: 'app-image-input',
  templateUrl: './imageInput.component.html',
  styleUrls: ['./imageInput.component.css'],
  encapsulation: ViewEncapsulation.None,
})

export class ImageInputComponent implements OnInit {

  @Input() src: string;
  @Input() width: string;
  @Input() height: string;
  @Input() maxWidth: string;
  @Input() maxHeight: string;
  @Input() inputStorageName: string;
  @Input() inputContainerName: string;
  @Input() inputContainerPath: string;
  @Input() containerName: string;
  @Input() images: string[];
  @Input() allowedTypes: string[];

  @Output() fileChanged: EventEmitter<string> = new EventEmitter<string>();

  private isUploading: boolean;
  private acceptTypes: string;
  private styles: any;
  private placeholderImageUrl: string = 'https://staticconent.blob.core.windows.net/backoffice/images/no-image.jpg';

  constructor(private blobStorageService: BlobStorageService) { }

  ngOnInit() {
    this.styles = {
      'width': 'auto',
      'height': Boolean(this.height) ? this.height : 'auto',
      'max-width': Boolean(this.maxWidth) ? this.maxWidth : '100%',
      'max-height': Boolean(this.maxHeight) ? this.maxHeight : 'auto',
      'border': '1px solid #bbb'
    };
    this.acceptTypes = this.allowedTypes.join(",");
  }

  imageSelection(event) {
    this.src = event;
    this.fileChangedEmit(this.src);
  }


  public imageClick(fileInput: HTMLElement) {
    if (!this.isUploading) {
      fileInput.click();
    }
  }

  public resetImage() {
    this.src = null;
    this.fileChangedEmit(this.src);
  }

  public async handleFileChanged(files: FileList) {

    const reader = new FileReader();
    reader.onload = (e: any) => {
      this.src = e.target.result;
    }

    reader.readAsDataURL(files[0]);

    this.isUploading = true;

    const data = await this.blobStorageService.uploadFile(
      this.inputStorageName,
      this.inputContainerName,
      this.inputContainerPath,
      Array.from(files)).toPromise();

    if (data && Array.isArray(data) && data.length > 0) {
      const imageUrl = data[0].url.replace(this.inputContainerName, this.containerName);

      this.isUploading = false;

      this.fileChangedEmit(imageUrl);
    }
  }

  private fileChangedEmit(imageUrl: string) {
    this.fileChanged.emit(imageUrl);
  }

  public showReset(): boolean {
    return Boolean(this.src);
  }

  public showSelect(): boolean {
    return this.images && this.images.length > 0;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/imageInput/imageInput.component.ts